import { forwardRef } from "react";
import { CalendarIcon } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * DateInput — Native <input type="date|month"> yang seragam dengan icon calendar di kanan.
 * Native `::-webkit-calendar-picker-indicator` di-hide (transparan tapi tetap klik-able penuh input),
 * custom <CalendarIcon> diletakkan absolute di kanan. Konsisten di seluruh app.
 *
 * Props: semua props <Input> standar diteruskan (value, onChange, disabled, className, etc.).
 * Extra:
 *  - variant: "date" (default) | "month"
 *  - iconClassName: override warna/ukuran icon.
 */
const DateInput = forwardRef(function DateInput(
  { variant = "date", className = "", wrapperClassName = "", iconClassName = "", ...props },
  ref
) {
  const type = variant === "month" ? "month" : "date";
  return (
    <div className={`relative ${wrapperClassName}`}>
      <Input
        ref={ref}
        type={type}
        {...props}
        className={`pr-10 [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:cursor-pointer ${className}`}
      />
      <CalendarIcon
        className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A0A3A8] ${iconClassName}`}
      />
    </div>
  );
});

export default DateInput;
